import { useEffect } from "react";
// @ts-ignore
import { useCopilotKit } from "@copilotkit/react-core/v2";

const isEnabled = () => sessionStorage.getItem("logStriimAiToolCalls") === "true";

export const useToolCallLogging = () => {
    const { copilotkit } = useCopilotKit();

    useEffect(() => {
        const subscription = copilotkit.subscribe({
            onToolExecutionStart: ({ toolName, args }: { toolName: string; args: unknown }) => {
                if (!isEnabled()) return;
                console.log(`[AI tool] ${toolName} called`, args);
            },
            onToolExecutionEnd: ({ toolName, result, error }: { toolName: string; result: string; error?: string }) => {
                if (!isEnabled()) return;
                if (error) {
                    console.log(`[AI tool] ${toolName} failed`, error);
                } else {
                    console.log(`[AI tool] ${toolName} completed`, result);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [copilotkit]);
};
